import { render } from "./locales.vue?vue&type=template&id=e9426e34&scoped=true"
import script from "./locales.vue?vue&type=script&lang=js"
export * from "./locales.vue?vue&type=script&lang=js"

import "./locales.vue?vue&type=style&index=0&id=e9426e34&scoped=true&lang=scss"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-e9426e34"]])

export default __exports__